import React from 'react';

export interface IRowListItem {
    label: string;
    value: React.ReactNode;
}

interface IProps {
    rows: IRowListItem[];
}

const RowListsBox = ({ rows }: IProps) => (
    <div className="rounded-md border border-utilityGray200 bg-utilityGray300 p-2 space-y-0.5">
        {rows.map((row, idx) => (
            <div key={idx} className="flex items-center gap-1.5 ">
                <h6 className="text-xs leading-[1.5] font-medium text-textSecondary">{row.label}</h6>
                <p className="text-xs leading-[1.5] font-normal text-gray500">{row.value}</p>
            </div>
        ))}
    </div>
);

export default RowListsBox;
